import { Marker, Popup } from 'react-leaflet';
import './pin.scss';
import { Link } from 'react-router-dom';
import L from 'leaflet';

// Создание кастомной иконки
const customIcon = new L.Icon({
  iconUrl: '/marker-icon-2x.png', 
  iconSize: [25, 41], // Размер иконки
  iconAnchor: [12, 41], // Точка крепления (например, "основание маркера")
});

function Pin({ item }) {
  return (
    <Marker
      position={[item.latitude, item.longitude]}
      icon={customIcon} // Применение кастомной иконки
    >
      <Popup>
        <div className="popupContainer">
          {item.images?.[0] ? (
            typeof item.images[0] === 'string' ? (
              // Если `item.images[0]` — строка
              <img src={item.images[0]} alt="product image" />
            ) : item.images[0].url ? (
              // Если это объект с `url`
              <img src={item.images[0].url} alt="product image" />
            ) : (
              // Если ничего из вышеперечисленного
              <img src="/noproduct.webp" alt="default product image" />
            )
          ) : (
            <img src="/noproduct.webp" alt="default product image" />
          )}
          <div className="textContainer">
            <Link to={`/${item.id}`}>{item.title}</Link>
            <span>
            {item.country}, {item.city}
          </span>
            <b>$ {item.price}</b>
          </div>
        </div>
      </Popup>
    </Marker>
  );
}

export default Pin;
